import {LinkEntry} from "../types/LinkEntry";

let NavData: LinkEntry[] = [
    {
        id: "1",
        link: "/home",
        title: "Home",
    },
    {
        id: "2",
        link: "/itinerary",
        title: "Details"
    },
    {
        id: "3",
        link: "/rsvp",
        title: "RSVP"
    },
    {
        id: "6",
        link: "/accommodations",
        title: "Accommodations"
    },
    {
        id: "9",
        link: "/transportation",
        title: "Transportation"
    },
    {
        id: "7",
        link: "/faq",
        title: "Q & A"
    },
    {
        id: "8",
        link: "/things-to-do",
        title: "Things To Do"
    },
    {
        id: "6",
        link: "https://registry.theknot.com/lea-tomaswick-nick-reed-june-2026-pa/67375102",
        title: "Registry"
    },
    {
        id: "5",
        link: "/gallery",
        title: "Gallery"
    }
];

export default NavData;